var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jobmatchpage" },
    [
      _vm.initialized === true
        ? [
            _vm.showResultPage === false
              ? _c("StartPage", {
                  attrs: { content: _vm.content.startPage, title: _vm.title },
                })
              : _c("JobMatchResultContainer", {
                  attrs: {
                    content: _vm.content.resultPage,
                    settings: _vm.settings,
                    jobApplicationAccess: _vm.jobApplicationAccess,
                  },
                }),
          ]
        : _c(
            "div",
            { staticClass: "text-center mt-5" },
            [_c("b-spinner", { attrs: { variant: "brand-light" } })],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }